export default {
  title: 'Dyscyplina',
  type: 'object',
  properties: {
    name: {
      title: 'schema.sport.name',
      type: 'string',
      fieldRequired: true
    }
  }
};
